import { QueryClient, defaultShouldDehydrateQuery, isServer } from '@tanstack/react-query'

let browserQueryClient: QueryClient | undefined

/**
 * Creates a new query client for the server or returns the existing one for the browser.
 * @returns {QueryClient}
 */
function makeQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 60 * 1000, // 1 minute default
        gcTime: 10 * 60 * 1000, // Keep unused data for 10 min
      },
      dehydrate: {
        shouldDehydrateQuery: (query) =>
          defaultShouldDehydrateQuery(query) || query.state.status === 'pending',
      },
    },
  })
}

/**
 * Retrieves the QueryClient instance for the current environment.
 * - **Server**: Always returns a new instance to prevent sharing cache state between multiple users/requests.
 * - **Browser**: Returns a singleton instance to ensure the cache is persisted throughout the user's session.
 * @returns {QueryClient} The environment-specific
 */
export function getQueryClient() {
  if (isServer) {
    return makeQueryClient()
  }

  browserQueryClient ??= makeQueryClient()

  return browserQueryClient
}
